const seo = {
    ka: {
        home: {
            title: "ტკბილეულის მაღაზია – Captain Candy",
            description: "Captain Candy-ში გთავაზობთ უმაღლესი ხარისხის ტკბილეულს. აღმოაჩინეთ ჟელეები, შოკოლადი, ლაკრიცი, ზეფირი და სხვა ტკბილი საგანძური.",
        },
        products: {
            title: "პროდუქცია | Captain Candy",
            description: "აღმოაჩინეთ Captain Candy-ის მრავალფეროვანი ტკბილეული და შეარჩიეთ თქვენი საყვარელი გემო საუკეთესო მომწოდებლებისგან.",
        },
        about: {
            title: "ჩვენ შესახებ | Captain Candy",
            description: "გაიცანით Captain Candy-ის ისტორია, ჩვენი უნიკალური მაღაზიები და ტკბილი საგანძურის აღმოჩენის იდეა.",
        },
        captainStory: {
            title: "კაპიტნის ამბავი | Captain Candy",
            description: "გაიგეთ, როგორ აღმოაჩინა კაპიტანმა თავისი ნამდვილი საგანძური და ტკბილეულის ჯადოსნური სამყარო.",
        },
        stores: {
            title: "მაღაზიები | Captain Candy",
            description: "იპოვეთ Captain Candy-ის ოფიციალური მაღაზიები საქართველოში და ევროპის სხვა ქალაქებში, მათი მისამართებითა და სამუშაო საათებით.",
        },
        career: {
            title: "კარიერა | Captain Candy",
            description: "შემოუერთდით Captain Candy-ის გუნდს და დაიწყეთ თქვენი პროფესიული თავგადასავალი ჩვენს ეკიპაჟთან ერთად.",
        },
        faq: {
            title: "ხშირად დასმული კითხვები | Captain Candy",
            description: "იპოვეთ პასუხები Captain Candy-ის პროდუქტების, მაღაზიების, ჰიგიენის, შენახვისა და ფრანჩაიზინგის შესახებ.",
        },
        contact: {
            title: "დაგვიკავშირდით | Captain Candy",
            description: "დაუკავშირდით Captain Candy Georgia-ს შეკითხვების, მოთხოვნებისა და თანამშრომლობის შესახებ.",
        },
        confirm: {
            title: "ელფოსტის დადასტურება | Captain Candy",
            description: "Captain Candy-ის ელფოსტის გამოწერის დადასტურება.",
        },
        franchising: {
            title: "ფრანჩაიზინგი | Captain Candy",
            description: "გაიგეთ მეტი Captain Candy-ის ფრანჩაიზის შესაძლებლობების შესახებ და შეავსეთ თანამშრომლობის კითხვარი.",
        },
        privacy: {
            title: "პერსონალური მონაცემების დამუშავება | Captain Candy",
            description: "გაეცანით Captain Candy-ის პერსონალური მონაცემების დამუშავებისა და დაცვის პირობებს.",
        },
        notFound: {
            title: "გვერდი ვერ მოიძებნა | Captain Candy",
            description: "მოთხოვნილი გვერდი ვერ მოიძებნა.",
        },
    },
    en: {
        home: {
            title: "Candy Shop – Captain Candy",
            description: "Discover premium sweets at Captain Candy, including gummies, chocolate, liquorice, marshmallows and many more sweet treasures.",
        },
        products: {
            title: "Products | Captain Candy",
            description: "Explore Captain Candy's wide selection of sweets and find your favourite flavours from carefully selected suppliers.",
        },
        about: {
            title: "About us | Captain Candy",
            description: "Discover the Captain Candy story, our unique shops and our passion for helping everyone find their sweet treasure.",
        },
        captainStory: {
            title: "The Captain's story | Captain Candy",
            description: "Learn how the Captain found his true treasure and discovered the magical world of sweets.",
        },
        stores: {
            title: "Stores | Captain Candy",
            description: "Find official Captain Candy stores in Georgia and other European cities, with addresses and opening hours.",
        },
        career: {
            title: "Career | Captain Candy",
            description: "Join the Captain Candy team and begin your professional adventure with our crew.",
        },
        faq: {
            title: "Frequently asked questions | Captain Candy",
            description: "Find answers about Captain Candy products, stores, hygiene, storage and franchising.",
        },
        contact: {
            title: "Contact us | Captain Candy",
            description: "Contact Captain Candy Georgia with questions, requests or cooperation enquiries.",
        },
        confirm: {
            title: "E-mail confirmation | Captain Candy",
            description: "Confirm your Captain Candy e-mail subscription.",
        },
        franchising: {
            title: "Franchising | Captain Candy",
            description: "Learn about Captain Candy franchise opportunities and complete our cooperation questionnaire.",
        },
        privacy: {
            title: "Personal data processing | Captain Candy",
            description: "Read the Captain Candy terms for personal data processing and protection.",
        },
        notFound: {
            title: "Page not found | Captain Candy",
            description: "The requested page could not be found.",
        },
    },
};

export { seo };
